import type { ProductLine } from '@popcart/core/v1';
import { Loading, useTitle } from '../../ui/bits';
import { SceneError } from '../../catalog/art';
import { ProductList } from '../../catalog/ProductList';
import { useShop } from '../ShopLayout';

/** /shop/:shopId/products — the shop's catalogue and stock (replaces the old Stock page). */
export function ProductsPage() {
  useTitle('Products & stock');
  const { shopId, base: shopBase, today, todayQuery } = useShop();
  const lines = today?.shop.lines as ProductLine[] | undefined;
  if (!lines) {
    return todayQuery.isError ? (
      <section className="card">
        <SceneError error={todayQuery.error} onRetry={() => void todayQuery.refetch()} />
      </section>
    ) : (
      <Loading label="Loading products" rows={3} />
    );
  }
  const base = `${shopBase}/products`;
  return (
    <ProductList
      scope="shop"
      shopId={shopId}
      lines={lines}
      editPath={(p) => `${base}/${encodeURIComponent(p.id)}`}
      newPath={`${base}/new`}
      heading="Products & stock"
      sub="Tap to edit · the switch hides it right away"
    />
  );
}
